import "./components/InstallPrompt/deferredInstall";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider, authWebResources } from "@ferrivia/auth-web";
import { chatUiResources } from "@ferrivia/chat-ui";
import { labUiResources } from "@ferrivia/lab-ui";
import { questionnaireUiResources } from "@ferrivia/questionnaire-ui";
import { createI18n, I18nProvider, mergeResources, resolveLocale } from "@ferrivia/i18n";
import { App } from "./App";
import { AppLaunchTracker } from "./components/InstallPrompt";
import { UpdateBanner } from "./components/UpdateBanner";
import { readCachedSession, toSessionSeed } from "./offline/cachedSession";
import { purgeClientState } from "./offline/purge";
import { clientResources, usOverlayResources } from "./resources";
import { MARKET } from "./lib/market";
import "./styles.css";

const CLIENT_DEFAULT_LOCALE = "fi" as const;

const i18n = createI18n({
  resources: mergeResources(
    clientResources,
    authWebResources,
    chatUiResources,
    labUiResources,
    questionnaireUiResources,
  ),
  locale: resolveLocale({ defaultLocale: CLIENT_DEFAULT_LOCALE }),
  market: MARKET,
  overlays: usOverlayResources,
  fallbackLng: CLIENT_DEFAULT_LOCALE,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <AuthProvider
        baseUrl={import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8080"}
        source="web-client"
        readCachedSession={() => {
          const cached = readCachedSession();
          return cached ? toSessionSeed(cached) : null;
        }}
        onUnauthorized={purgeClientState}
      >
        <App />
        <UpdateBanner />
        <AppLaunchTracker />
      </AuthProvider>
    </I18nProvider>
  </StrictMode>,
);
